import { useReducer, useEffect, useCallback } from "react";
function reducer(state, action) {
    const { currentPage, itemsPerPage, maxItems } = state;
    const maxPage = Math.ceil(maxItems / itemsPerPage);
    switch (action.type) {
        case "nextPage":
            if (currentPage >= maxPage) {
                return Object.assign(Object.assign({}, state), { currentPage: maxPage });
            }
            return Object.assign(Object.assign({}, state), { currentPage: currentPage + 1 });
        case "previousPage":
            if (currentPage <= 1) {
                return Object.assign(Object.assign({}, state), { currentPage: 1 });
            }
            return Object.assign(Object.assign({}, state), { currentPage: currentPage - 1 });
        case "changeItemsPerPage":
            if (itemsPerPage !== action.value && action.value > 0) {
                const maxNewPage = Math.ceil(maxItems / action.value) || 1;
                return Object.assign(Object.assign({}, state), { itemsPerPage: action.value, currentPage: currentPage > maxNewPage ? maxNewPage : currentPage });
            }
            return state;
        case "changeMaxItems":
            if (maxItems !== action.value) {
                const maxNewPage = Math.ceil(action.value / itemsPerPage) || 1;
                return Object.assign(Object.assign({}, state), { maxItems: action.value, currentPage: currentPage > maxNewPage ? maxNewPage : currentPage });
            }
            return state;
        default:
            throw new Error(`[usePagination] This action doesn't exist: ${action} `);
    }
}
export default function usePagination(itemsLength) {
    const initialState = {
        currentPage: 1,
        itemsPerPage: 10,
        maxItems: itemsLength,
    };
    const [state, dispatch] = useReducer(reducer, initialState);
    useEffect(() => {
        dispatch({ type: "changeMaxItems", value: itemsLength });
    }, [itemsLength]);
    const goNext = useCallback(() => {
        dispatch({ type: "nextPage" });
    }, [dispatch]);
    const goPrevious = useCallback(() => {
        dispatch({ type: "previousPage" });
    }, [dispatch]);
    const changeItemsPerPage = useCallback((value) => {
        dispatch({ type: "changeItemsPerPage", value });
    }, [dispatch]);
    return { state, goNext, goPrevious, changeItemsPerPage };
}
//# sourceMappingURL=usePagination.js.map